var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "test_list_wrap"
    },
    [
      _c("div", { staticClass: "test_list_header" }, [
        _c("h2", [_vm._v("测验列表")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "test_list_header_search" },
          [
            _c(
              "el-select",
              {
                attrs: { clearable: "", placeholder: "全部教学章节" },
                on: { change: _vm.searchChapter },
                model: {
                  value: _vm.selectedChapterValue,
                  callback: function($$v) {
                    _vm.selectedChapterValue = $$v
                  },
                  expression: "selectedChapterValue"
                }
              },
              _vm._l(_vm.selectedChapterOpt, function(item) {
                return _c("el-option", {
                  key: item.id,
                  attrs: { label: item.catalogName, value: item.id }
                })
              }),
              1
            ),
            _vm._v(" "),
            _c("el-input", {
              attrs: {
                "prefix-icon": "el-icon-search",
                placeholder: "请输入测验名称",
                clearable: ""
              },
              nativeOn: {
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.searchTestingName(_vm.testingName)
                }
              },
              model: {
                value: _vm.testingName,
                callback: function($$v) {
                  _vm.testingName = $$v
                },
                expression: "testingName"
              }
            }),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: { plain: "" },
                on: {
                  click: function($event) {
                    return _vm.search()
                  }
                }
              },
              [_vm._v("查询")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.userType == 0 || _vm.userType == 1
        ? _c(
            "div",
            { staticClass: "teacher_test_list_table" },
            [
              _c(
                "el-table",
                {
                  staticClass: "collegeTable",
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.tableData,
                    "tooltip-effect": "dark",
                    height: _vm.height,
                    "header-cell-style": _vm.headerCellStyle,
                    "empty-text": _vm.empty
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "paperName",
                      label: "测验名称",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "总分" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(scope.row.totalScore.split(".")[0]) +
                                    "分/" +
                                    _vm._s(scope.row.totalQuestion) +
                                    "题"
                                )
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3820229202
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "notSumbit", label: "未提交", width: "100" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "sumbit", label: "已提交", width: "100" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "平均分" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("span", [
                                _vm._v(_vm._s(scope.row.average) + "分")
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3609307080
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { fixed: "right", label: "操作", width: "240" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: { round: "", size: "small" },
                                  nativeOn: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.previewRow(
                                        scope.$index,
                                        _vm.tableData
                                      )
                                    }
                                  }
                                },
                                [_vm._v("预览")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: { round: "", size: "small" },
                                  nativeOn: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.seeRow(scope.row)
                                    }
                                  }
                                },
                                [_vm._v("查看")]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      161824025
                    )
                  })
                ],
                1
              )
            ],
            1
          )
        : _c(
            "div",
            {
              staticClass: "student_test_list_table",
              style: "height:" + (_vm.height + 50) + "px"
            },
            [
              _vm.tableData.length > 0
                ? _c(
                    "ul",
                    { style: "height:" + (_vm.height - 5) + "px" },
                    _vm._l(_vm.tableData, function(item, i) {
                      return _c(
                        "li",
                        { key: i },
                        [
                          _c("div", { staticClass: "list_left" }, [
                            _c("div", { staticClass: "list_info" }, [
                              _c("img", {
                                attrs: {
                                  src: require("../../../../../../static/images/study/testImg/icon.png"),
                                  alt: ""
                                }
                              }),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  _vm._s(item.paperName) +
                                    "（" +
                                    _vm._s(item.totalScore.split(".")[0]) +
                                    "分/" +
                                    _vm._s(item.totalQuestion) +
                                    "题）"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            item.userPaperStatus == "answerDetail"
                              ? _c("div", { staticClass: "list_score" }, [
                                  _c("i", [_vm._v("|")]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v("得分："),
                                    _c("span", [_vm._v(_vm._s(item.userScore))])
                                  ])
                                ])
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          item.userPaperStatus == "answerDetail"
                            ? _c(
                                "el-button",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.answerDetails(item)
                                    }
                                  }
                                },
                                [_vm._v("作答详情")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          item.userPaperStatus1 == "answerDetail"
                            ? _c(
                                "el-button",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.answerDetails(item)
                                    }
                                  }
                                },
                                [_vm._v("作答详情")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          item.userPaperStatus == "continueQuestion"
                            ? _c(
                                "el-button",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.giveResponse(
                                        item.userPaperStatus,
                                        item
                                      )
                                    }
                                  }
                                },
                                [_vm._v("继续作答")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          item.userPaperStatus == "startQuestion"
                            ? _c(
                                "el-button",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.giveResponse(
                                        item.userPaperStatus,
                                        item
                                      )
                                    }
                                  }
                                },
                                [_vm._v("开始作答")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          item.userPaperStatus1 == "againQuestion"
                            ? _c(
                                "el-button",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.giveResponse(
                                        item.userPaperStatus,
                                        item,
                                        1
                                      )
                                    }
                                  }
                                },
                                [_vm._v("重做一遍")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          item.userPaperStatus == "lock"
                            ? _c("span", { staticClass: "lock" }, [
                                _vm._v("暂未开放")
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    }),
                    0
                  )
                : _c("div", { staticClass: "no_list" }, [
                    _c("img", {
                      attrs: {
                        src: require("../../../../../../static/images/wujieguo.png")
                      }
                    }),
                    _vm._v(" "),
                    _c("p", [_vm._v("暂无数据")])
                  ])
            ]
          )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-533af858", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-533af858","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/studyCenter/switch/testing/testList.vue
// module id = null
// module chunks = 